var map = {
	"./w1.png": "1IXL",
	"./w10.png": "Umgi",
	"./w11.png": "SBdJ",
	"./w12.png": "yDa1",
	"./w13.png": "JuK5",
	"./w14.png": "J1Uh",
	"./w16.png": "owgN",
	"./w17.png": "8CQ/",
	"./w18.png": "0v7W",
	"./w19.png": "dkIh",
	"./w2.png": "lIgy",
	"./w20.png": "ZkvO",
	"./w21.png": "Wq1d",
	"./w22.png": "lMBL",
	"./w25.png": "D3QZ",
	"./w26.png": "D8to",
	"./w27.png": "EUby",
	"./w28.png": "rLRl",
	"./w29.png": "fmRm",
	"./w3.png": "OdXG",
	"./w32.png": "bITb",
	"./w34.png": "XhdC",
	"./w36.png": "J5JS",
	"./w39.png": "Ug8x",
	"./w4.png": "siXm",
	"./w40.png": "BPZs",
	"./w41.png": "v1E/",
	"./w42.png": "NaFZ",
	"./w43.png": "hstY",
	"./w47.png": "4pkc",
	"./w48.png": "e8S7",
	"./w49.png": "/X8f",
	"./w5.png": "D/X0",
	"./w50.png": "Svft",
	"./w51.png": "311X",
	"./w54.png": "rge0",
	"./w55.png": "vpEW",
	"./w57.png": "u1nV",
	"./w6.png": "6xmo",
	"./w8.png": "6UmF",
	"./w9.png": "24mF",
	"./w999.png": "PD5f"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2BtQ";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/darkSportsLogo ^\.\/w.*\.png$
// module id = 2BtQ
// module chunks = 3